import React, { useEffect } from 'react';
import queryString from 'query-string';

import { useLocalization } from "../../containers/I18nProvider";
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import logo from './img/mach-logo.png';
import bciLogo from './img/bci-logo-footer.png';
import LoginForm from './LoginForm';

const Login = ({ location }) => {
  const { translate } = useLocalization();
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  useEffect(() => {
    document.body.className = 'mach-oauth-body';
    document.title = 'MACH';
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <div className="mach-oauth">
      <div className="mach-logo">
        <img src={logo} alt="MACH Logo" />
      </div>
      <div className="mach-divider"></div>
      {
        _validateParams()
          ? <LoginForm
          api={api}
          location={location} />
          :<RequestLoginErrorMessage
          onlyMessage={true}
          message={translate('RequestLoginErrorMessage')} />}
      <footer className="mach-footer">
        <p>©{currentYear} {translate('FooterCopyright')} <img src={bciLogo} alt="BCI Logo" className="bci-logo" /> {translate('FooterTagline')}</p>
        <p>{translate('FooterContactInfo')}</p>
      </footer>
    </div>
  );
}

export default Login;
